<template>
  <div class="item">
    <h3 v-if="!isMobile">{{ title }}</h3>
    <div class="content-wrapper">
      <div class="content">
        <h3 v-if="isMobile">{{ title }}</h3>
        <div
          v-dompurify-html="description"
          class="description"
        />
      </div>
      <div class="img-container">
        <img
          :src="img.source"
          :alt="img.alt"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    props: {
      title: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: true
      },
      img: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapGetters('device', ['isMobile'])
    }
  }
</script>

<style
  lang="scss"
  scoped
>
  @import '~assets/styles/common.scss';

  .item {
    margin-left: -16px;
    margin-right: -16px;

    @include bp-mf-tablet {
      margin-left: 0;
      margin-right: 0;
    }

    .content-wrapper {
      display: flex;
      flex-direction: column;

      @include bp-mf-tablet {
        flex-direction: row;
        justify-content: space-between;
      }
    }

    @include bp-mf-tablet {
      margin-bottom: 48px;
    }

    .img-container {
      order: 0;
      height: 180px;
      width: 100%;
      overflow: hidden;

      @include bp-mf-tablet {
        text-align: right;
        height: auto;
        width: 50%;
        margin-top: -20px;
      }

      @include bp-mf-desktop {
        width: 540px;
      }

      img {
        width: 100%;
        margin: 0 auto;
      }
    }

    h3 {
      font-size: em(21, 16);
      line-height: 28px;
      font-weight: 500;
      margin-top: 0;
      color: $blue-dark;
      margin-bottom: 24px;

      @include bp-mf-tablet {
        font-size: em(28, 16);
        line-height: 36px;
        padding: 0;
        margin-bottom: 32px;
      }
    }

    .content {
      order: 1;
      padding: 24px 16px 46px;

      @include bp-mf-tablet {
        order: 0;
        width: 46%;
        padding: 0;
      }

      .description {
        ::v-deep p {
          margin-top: 0 !important;
          margin-bottom: 24px;
        }

        font-weight: 400;
        font-size: em(16, 16);
        line-height: 24px;
      }
    }
  }
</style>
